export const AI_SCRUBBING_RECOMMENDED_RUBRIC_TEMPLATE =
  'Disqualify nominations that are (a) not predominantly in English; '
  + '(b) primarily marketing language with no measurable outcomes; '
  + '(c) about products/services Microsoft does not partner on. '
  + 'Do not judge length - abstract length is enforced separately by a deterministic rule. '
  + 'Be conservative - when in doubt, do not disqualify.';
